/**
 * YouTube Video Loader
 * Handles both inline YouTube embeds and modal-based YouTube videos
 * - Loads thumbnail images on page load
 * - Replaces with iframe on click (inline) or modal open
 */

document.addEventListener("turbo:load", function () {
  // Common function to create YouTube iframe
  function createYouTubeIframe(embedId) {
    const iframe = document.createElement("iframe");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    );
    iframe.setAttribute(
      "src",
      `https://www.youtube-nocookie.com/embed/${embedId}?rel=0&showinfo=0&autoplay=1&enablejsapi=1`
    );
    return iframe;
  }

  // Common function to load thumbnail image
  function loadYouTubeThumbnail(element, embedId, alt) {
    const source = `https://img.youtube.com/vi/${embedId}/sddefault.jpg`;
    const image = new Image();
    image.src = source;
    if (alt) image.alt = alt;

    image.addEventListener("load", function() {
      // Only append if image doesn't already exist
      if (!element.querySelector("img")) {
        element.appendChild(image);
      }
    });
  }

  // 1. Handle inline YouTube embeds (with class "youtube")
  const inlineYouTubeElements = document.querySelectorAll(".youtube");

  inlineYouTubeElements.forEach(function(element) {
    const embedId = element.dataset.embed;
    const alt = element.dataset.alt;

    if (!embedId) return;

    // Load thumbnail
    loadYouTubeThumbnail(element, embedId, alt);

    // Handle click to replace with iframe
    element.addEventListener("click", function() {
      const iframe = createYouTubeIframe(this.dataset.embed);
      this.innerHTML = "";
      this.appendChild(iframe);
    });
  });

  // 2. Handle modal-based YouTube videos
  const modalTriggers = document.querySelectorAll("[data-bs-toggle='modal'][data-embed]");
  const modal = document.querySelector("#youtubeModal");
  const modalVideoItem = document.querySelector("#youtubeModalVideoItem");

  if (modal && modalVideoItem && modalTriggers.length > 0) {
    // Load thumbnails for modal triggers
    modalTriggers.forEach(function(element) {
      const embedId = element.dataset.embed;
      const alt = element.dataset.alt;

      if (!embedId) return;

      loadYouTubeThumbnail(element, embedId, alt);
    });

    // Remove any existing event listeners to prevent duplicates
    modal.removeEventListener("shown.bs.modal", handleModalShown);
    modal.removeEventListener("hide.bs.modal", handleModalHide);

    // Add fresh event listeners
    modal.addEventListener("shown.bs.modal", handleModalShown);
    modal.addEventListener("hide.bs.modal", handleModalHide);

    function handleModalShown(e) {
      // Clear any existing content first
      modalVideoItem.innerHTML = "";

      const embedId = e.relatedTarget.dataset.embed;
      if (!embedId) return;

      const iframe = createYouTubeIframe(embedId);
      modalVideoItem.appendChild(iframe);

      // Track video start with analytics
      if (window.sa_event) {
        sa_event("video_start", {
          video_provider: "youtube",
          video_url: `https://www.youtube.com/watch?v=${embedId}`
        });
      }
    }

    function handleModalHide(e) {
      modalVideoItem.innerHTML = "";
    }
  }
});

